import React from 'react'
import RoadMap from '../components/RoadMap'
import Header from '../components/Header'
import { Helmet } from 'react-helmet'

export default function WebRoadMap() {
  return (
    <div className=''>
                        <Helmet>
        <title>Features | Andromeda</title>
        <meta name="description" content="Explore the Andromeda-Sim roadmap, showcasing our ongoing commitment to enhancing software with new features. From quality control management to advanced analytics and improved user experience, stay updated on our innovations and upcoming releases for optimal performance." />
        <meta name="keywords" content="Andromeda-Sim roadmap, software roadmap, quality control management, analytics tools, reporting tools, user experience, software enhancements, simulator management, aviation software features, advanced analytics, future releases" />
      </Helmet>
      <div className=''><Header/></div>
        <RoadMap/>
    </div>
  )
}
